import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-shell',
    templateUrl: './shell.component.html',
    standalone: false
})
export class ShellComponent {
  title = 'shell';

  userDetails = {} as models.UserDetails;

  constructor(private http: HttpClient, private activeRoute: ActivatedRoute) {

    activeRoute.data.subscribe(data => this.userDetails = data.userDetails[0]);

  }
}
